import apiURl from '../constant/urls.js';
import {ALL_TENANTS} from '../constant/urls.js';

export const GetAllTenants = async () => {
    var token = localStorage.getItem('userToken');
    const apiCall = await fetch(`${apiURl}${ALL_TENANTS}`,{
        method:'GET',
        headers:{
            'Content-Type':'application/json',
            'Authorization':`Bearer ${token}`
        }
    });
    const response = await apiCall.json();
    return response;    
}